import * as yup from "yup";
export const RL1SummarySetupSchema = yup.object().shape({
  rl1FiledOnPaper: yup.string().required("Filed On Paper is required!"),
  rl1FiledOnline: yup.string().required("Filed Online is required!"),
});
